import { render, staticRenderFns } from "./student_list.vue?vue&type=template&id=3b07c3cc&scoped=true"
import script from "./student_list.vue?vue&type=script&lang=js"
export * from "./student_list.vue?vue&type=script&lang=js"
import style0 from "./student_list.vue?vue&type=style&index=0&id=3b07c3cc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b07c3cc",
  null
  
)

export default component.exports